import { GoogleAnalyticsService } from './analytics/google-analytics.service';
import { Component, NgZone, PLATFORM_ID, inject, ChangeDetectionStrategy } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalService } from './core/services/local.service';
import { ToastHostComponent } from './shared/components/ui/toast/toast-host.component';
import { ConfirmHostComponent } from './shared/components/ui/confirm/confirm-host.component';


@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    TranslateModule,
    ToastHostComponent,
    ConfirmHostComponent,
  ],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.scss'
})
export class AppComponent {

  private platformId = inject(PLATFORM_ID);
  private ngZone = inject(NgZone);

  navigating = false;

  constructor(
    private ga: GoogleAnalyticsService,
    private translateService: TranslateService,
    private localService: LocalService,
    private router: Router,
  ) {
    this.ga.start();
    this.translateService.addLangs(['id', 'en']);
    this.translateService.setDefaultLang('en');

    this.localService.initEnvironment();

    if (isPlatformBrowser(this.platformId)) {
      this.router.events.subscribe(event => {
        if (event instanceof NavigationStart) {
          this.navigating = true;
        }

        if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
          this.navigating = false;
        }

      });
    }
  }

  ngOnInit() {
    const savedLang = this.localService.getData('lang');
    this.translateService.use(savedLang || 'en');

    this.initScrollbarAutoHide();
  }

  private scrollIdleTimer: any = null;

  private initScrollbarAutoHide() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const root = document.documentElement;
    // capture:true so it also fires for inner scrollable containers, passive for perf.
    // Outside the zone: it only toggles a class, so it must not run change detection
    // on every scroll frame (nor when the idle timer fires).
    this.ngZone.runOutsideAngular(() => {
      window.addEventListener('scroll', () => {
        root.classList.add('is-scrolling');
        if (this.scrollIdleTimer) {
          clearTimeout(this.scrollIdleTimer);
        }
        this.scrollIdleTimer = setTimeout(() => root.classList.remove('is-scrolling'), 900);
      }, { passive: true, capture: true });
    });
  }
}
